import QueryBuilder from "../helpers/QueryBuilder";
import PackingService from "../services/PackingService";

const state = {
  packings: [],
  queryFilters: {
    name: "",
    page: 0,
    size: 10
  },
  loading: false,
  totalPages: 1
};

const mutations = {
  setPackings(state, packings) {
    state.packings = packings;
  },
  addPacking(state, packing) {
    packing.id = new Date().getTime();
    state.packings.push(packing);
  },
  setTotalPages(state, totalPages) {
    state.totalPages = totalPages;
  },
  setQueryFilters(state, queryItem) {
    state.queryFilters.name = queryItem.name;
  },
  resetFilters(state) {
    state.queryFilters.page = 0;
    state.queryFilters.name = "";
  },
  setPage(state, page) {
    state.queryFilters.page = page;
  },
  toggleLoading(state, payload) {
    state.loading = payload;
  }
};
const actions = {
  getPackings({ commit, state }) {
    commit("toggleLoading", true);
    const queryString = QueryBuilder.getQueryString(state.queryFilters);
    PackingService.getPackings(queryString).then(({ data }) => {
      commit("setTotalPages", data.totalPages);
      commit("setPackings", data.content);
      commit("toggleLoading", false);
    });
  },
  createPacking({ commit, state }, packing) {
    return new Promise((resolve, reject) => {
      PackingService.create(packing).then(
        ({ data }) => {
          resolve(data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  editPacking({ commit, state }, packing) {
    return new Promise((resolve, reject) => {
      PackingService.update(packing).then(
        ({ data }) => {
          resolve(data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  removePacking({ commit, state }, packingId) {
    return new Promise((resolve, reject) => {
      PackingService.remove(packingId).then(
        ({ data }) => {
          resolve(data);
        },
        error => {
          reject(error);
        }
      );
    });
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
